import { BrowserRouter } from 'react-router-dom'
import MoovyRouters from './moovyRouters'

const AppRoutes = () => {
  return (
    <BrowserRouter>
      <MoovyRouters />
    </BrowserRouter>
  )
}

export default AppRoutes
